import { createFileRoute, Outlet } from '@tanstack/react-router';

import { BackendContainer } from '@/components/backend/BackendContainer';
import { makeMetaTitle } from '@/modules/META';

export const Route = createFileRoute('/verwaltung/_global/benutzerinnen')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
  head: () => ({
    meta: [makeMetaTitle(['Benutzer*innen'])],
  }),
});

function RouteComponent() {
  return (
    <BackendContainer>
      <Outlet />
    </BackendContainer>
  );
}
